<div>
    <div class="card m-2">
        <div mat-dialog-title class="heading">View Metadata
            <!-- <mat-divider></mat-divider> -->
        </div>
        <div class="ml-3" class="properties" *ngIf="toggleUpdate">
            <div class="mt-2" style="text-align: center;">View the updated values</div>
            <div>
                <button class="closeButton mat-raised-button  float-right m-2"  (click)="onCancel()">Cancel</button>                    
            </div>
            <form #initiateForm="ngForm">
                <div *ngFor="let key of document.categoryMetaData.properties; index as i;">
                    <div *ngIf="key.required==true">
                        <div class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} *</span>
                            </div>
                            <input class="form-control" name="{{key.name}}"
                                [ngClass]="values[key.name]?'':'empty-input'" ngDefaultControl type="text" [(ngModel)]="values[key.name]"
                                required [disabled] ="true">
                        </div>                                                
                    </div>
                    <div *ngIf="key.required==false">
                        <div *ngIf="key.data_type=='str' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{key.name}} </span>
                            </div>
                            <input class="form-control" name="{{key.name}}" ngDefaultControl type="text" [(ngModel)]="values[key.name]" [disabled] ="true">
                        </div>                       
                    </div>
                </div>                
            </form>
        </div>
    </div>
</div>